// extracted by mini-css-extract-plugin
export default {"selected":"_9a35337e10","un":"d02a340b81"};